import { ContentWrapper } from "src/components/base";
import styled from "styled-components";

export const HomePageContentWrapper = styled(ContentWrapper)`
    padding: 40px 24px;
`;
